import { useEffect, useState } from "react";
import axios from "axios";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SUB = { gare: "Gare", "métro": "Métro", tram: "Tram", supermarket: "Supermarché", convenience: "Supérette" };
const STYLE = { station: ["#2B3029", "G"], shop: ["#3F7A4A", "S"] };

const home = L.divIcon({
  className: "",
  html: '<div style="width:30px;height:30px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);background:#7A3B2A;border:3px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.35)"></div>',
  iconSize: [30, 30],
  iconAnchor: [15, 30],
  popupAnchor: [0, -28],
});
const badge = (kind) =>
  L.divIcon({
    className: "",
    html: `<div style="width:28px;height:28px;border-radius:50%;background:${STYLE[kind][0]};border:3px solid #fff;color:#fff;font:700 13px/22px sans-serif;text-align:center;box-shadow:0 1px 4px rgba(0,0,0,.35)">${STYLE[kind][1]}</div>`,
    iconSize: [28, 28],
    iconAnchor: [14, 14],
  });
const walk = (m) => `${Math.max(1, Math.round(m / 80))} min à pied`;

export const ListingMap = ({ listing }) => {
  const [info, setInfo] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let tries = 0;
    let timer;
    const load = () => {
      axios.get(`${API}/listings/${listing.id}/map-info`, { withCredentials: true })
        .then(({ data }) => {
          setInfo(data);
          if (!data.pois_done && tries++ < 4) timer = setTimeout(load, 20000);
        })
        .catch(() => setFailed(true));
    };
    load();
    return () => clearTimeout(timer);
  }, [listing.id]);

  if (failed || !listing.address) return null;
  return (
    <div className="mt-10" data-testid="listing-map">
      <h2 className="font-serif text-2xl text-[#1A1A1A]">Localisation</h2>
      <div className="mt-5 aspect-[16/9] rounded-md overflow-hidden border border-[#E5E1D8] bg-[#EFECE5] relative z-0">
        {info && (
          <MapContainer center={[info.lat, info.lon]} zoom={16} scrollWheelZoom={false} className="h-full w-full" data-testid="listing-map-canvas">
            <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={[info.lat, info.lon]} icon={home}>
              <Popup>{listing.residence_name || listing.title}<br />{listing.address}</Popup>
            </Marker>
            {info.pois.map((p) => (
              <Marker key={p.kind} position={[p.lat, p.lon]} icon={badge(p.kind)}>
                <Popup>{SUB[p.sub] || ""} {p.name}<br />{walk(p.m)}</Popup>
              </Marker>
            ))}
          </MapContainer>
        )}
      </div>
      {info?.pois?.length > 0 && (
        <ul className="mt-3 flex flex-wrap gap-x-6 gap-y-2 text-sm text-[#1A1A1A]" data-testid="listing-map-legend">
          {info.pois.map((p) => (
            <li key={p.kind} className="flex items-center gap-2" data-testid={`listing-map-poi-${p.kind}`}>
              <span className="w-5 h-5 rounded-full text-white text-[11px] font-bold flex items-center justify-center" style={{ background: STYLE[p.kind][0] }}>{STYLE[p.kind][1]}</span>
              {SUB[p.sub] || ""} {p.name} · {walk(p.m)}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
